import { gql } from '@apollo/client';

export const LIST_PENDANTS = gql`
  query listSystems($limit: Int, $nextToken: String) {
    listSystems(limit: $limit, nextToken: $nextToken) {
      items {
        system_id
        configuration {
          pers_id
        }
        basic_info {
          pendant_status {
            sensor_id
            battery_state_of_charge
            connected
            last_heartbeat_utc
            version
            zone
          }
          system_status {
            system_state
            timestamp_utc
          }
        }
        advanced_info {
          organisation_setting {
            pers_region
          }
          sensor_pairing_events(start_date: "2023-09-20T00:00:00.000Z") {
            items {
              sensor_id
              timestamp_utc
            }
          }
        }
      }
      nextToken
    }
  }
`;
